import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Button, ButtonText } from '@morressier/alembic';
import { useFormContext } from 'react-hook-form';
import { IFormFieldState } from '.';
import { CustomFormFieldComponent } from 'src/components/FormField';
import { IPathObject } from './FormFieldSetModal';
import _ from 'lodash';

interface IFormFieldFormProps {
  fields: IFormFieldState[];
  onSubmit: (data: Record<string, unknown>) => void;
  onCancel: () => void;
  defaultValues?: IPathObject;
}

const FormFieldSet: React.FC<IFormFieldFormProps> = ({
  fields,
  onSubmit,
  onCancel,
  defaultValues
}) => {
  const {
    reset,
    handleSubmit,
    formState: { isSubmitting }
  } = useFormContext();

  function renderFieldInput(fieldState: IFormFieldState) {
    const fieldName = fieldState.formFieldDefinition.name;
    return (
      <CustomFormFieldComponent
        key={fieldName}
        config={fieldState.formFieldDefinition}
      />
    );
  }

  const onExit = () => {
    reset(defaultValues);
    onCancel();
  };

  const onReset = () => {
    const values = fields.reduce((acc, curr) => {
      _.set(acc, curr.formFieldDefinition.caseDataFields.main, null);
      return acc;
    }, {});

    reset(values);
  };

  return (
    <Flex flexDirection="column" gap={4}>
      <Flex flexDirection="column" gap={4}>
        {fields.map(fieldState => renderFieldInput(fieldState))}
      </Flex>

      <Flex gap={2} marginTop={4}>
        <ButtonText variant="caution" type="button" onClick={onReset}>
          Clear Data
        </ButtonText>
        <Button
          marginStart="auto"
          variant="secondary"
          onClick={onExit}
          borderRadius="small"
          type="button"
        >
          Exit Without Saving
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit(onSubmit)}
          borderRadius="small"
          isLoading={isSubmitting}
          loadingText="Saving..."
        >
          Save Changes
        </Button>
      </Flex>
    </Flex>
  );
};

export default FormFieldSet;
